import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { GridsterModule } from 'angular-gridster2';
import { MentionModule } from 'angular-mentions';
import { ResizableModule } from 'angular-resizable-element';
import { AngularDraggableModule } from 'angular2-draggable';
import { QRCodeModule } from 'angularx-qrcode';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxAngularQueryBuilderModule } from "ngx-angular-query-builder";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { QuillModule } from 'ngx-quill';
import { SlickCarouselModule } from 'ngx-slick-carousel';
//import { ToastUiImageEditorModule } from "ngx-tui-image-editor";

@NgModule({
    imports: [
        FullCalendarModule,
        GridsterModule,
        AngularDraggableModule,
        DragDropModule,
        SlickCarouselModule,
        NgxAngularQueryBuilderModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        InfiniteScrollModule,
        //ToastUiImageEditorModule,
        QRCodeModule,
        ResizableModule,
        QuillModule.forRoot(),
        MonacoEditorModule.forRoot(),
        NgxJsonViewerModule,
        PdfViewerModule,
        MentionModule,
        Ng2GoogleChartsModule,
        LazyLoadImageModule
    ],
    exports: [
        FullCalendarModule,
        GridsterModule,
        AngularDraggableModule,
        DragDropModule,
        SlickCarouselModule,
        NgxAngularQueryBuilderModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        InfiniteScrollModule,
        //ToastUiImageEditorModule,
        QRCodeModule,
        ResizableModule,
        QuillModule,
        MonacoEditorModule,
        NgxJsonViewerModule,
        PdfViewerModule,
        MentionModule,
        Ng2GoogleChartsModule,
        LazyLoadImageModule
    ]
})
export class OthersModule { }
